import {
  ICloudSourceRunStatus,
  useCloudSourceInfo,
} from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import React from 'react';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
import { Flex } from '@ui-library/misc';
import CloudSourceRunHistory from './cloudSourceRunHistory';

const CloudSourceHistoryTab = () => {
  const { runHistory, getRunHistory, source } = useCloudSourceInfo();
  const [date, setDate] = React.useState(moment().toISOString());
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    setLoading(false);
    getRunHistory(date).finally(() => setLoading(false));
  }, [date]);
  const data = (runHistory as ICloudSourceRunStatus[])?.reduce(
    (accum: ICloudSourceRunStatus[], record: ICloudSourceRunStatus) => {
      if (!record.taskRunId) {
        const recordWithError = runHistory?.find(
          (rec) => !!rec.error && rec.jobRunId === record.jobRunId,
        );
        const error =
          (recordWithError && `${recordWithError.taskId}: ${recordWithError.error}`) || '';
        accum.push({ ...record, error });
      }
      return accum;
    },
    [],
  );
  return (
    <div>
      <Space direction="vertical" size={24}>
        <Flex>
          <Space direction="horizontal" size={4}>
            <span>Started At </span>{' '}
            <DatePicker
              allowClear={false}
              onChange={(date) => {
                // eslint-disable-next-line @typescript-eslint/no-extra-non-null-assertion
                setDate(date!?.toISOString());
              }}
              disabledDate={(currentDate) =>
                currentDate.isAfter(moment()) ||
                currentDate.isBefore(moment(source.createdAt).startOf('day'))
              }
              defaultValue={moment(new Date())}
              format="MMM DD, YYYY"
            />
          </Space>
        </Flex>
        <CloudSourceRunHistory loading={loading} data={data!} />
      </Space>
    </div>
  );
};

export default CloudSourceHistoryTab;
